import React from 'react';
import ReactDOM from 'react-dom/client';
import './narbodica.css';
import './narb-auth/src/accessibility/layer3.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
